/**
 * @file 官方流程mutaions
 */

export default {
    changeIssueState(state, process) {
        state.topicData.topicInfo.process = process;
    },
    changeFollowerState(state, isFollower) {
        state.topicData.ext.qaOfficialInfo.isFollower = isFollower;
    },
    changeAuditState(state, isAudit) {
        state.topicData.ext.qaOfficialInfo.isAudit = isAudit;
    },
    changeOfficialFollowerName(state, userInfo) {
        state.topicData.ext.qaOfficialInfo.followUserInfo = Object.assign({}, userInfo);
    },
    changeOfficialAuditName(state, userInfo) {
        state.topicData.ext.qaOfficialInfo.auditUserInfo = Object.assign({}, userInfo);
    },
    changeQuestionProcess(state, query) {
        switch (query.questionCategory) {
            case 1: state.topicData.ext.qaOfficialInfo.process = 'OP_PENDING_FIXED';
                break;
            case 2: state.topicData.ext.qaOfficialInfo.process = 'OP_MISS_INFO';
                break;
            case 3: state.topicData.ext.qaOfficialInfo.process = 'OP_NOT_REAPPEAR';
                break;
        }
        Object.assign(state.topicData.ext.qaOfficialInfo, query);
    },
    changeOfficialProcess(state, process) {
        state.topicData.ext.qaOfficialInfo.process = process;
    },
    setAnswerReply(state, content) {
        state.topicData.ext.qaOfficialInfo.answerContent = content;
    },
    saveIssueList(state) {
        state.topicData.issueList = state.topicData.ext.qaOfficialInfo.issueList;
    },
    clearRelatedIssue(state) {
        state.topicData.ext.qaOfficialInfo.issueList = [];
    },
    saveAuditInfo(state, {data, type}) {
        if (type === 1) {
            state.topicData.ext.qaOfficialInfo.auditPassTime = data.lastModifyTime;
        }
        else {
            state.topicData.ext.qaOfficialInfo.auditRejectTime = data.lastModifyTime;
        }
        state.topicData.ext.qaOfficialInfo.auditDescription = data.auditDescription;
        state.topicData.ext.qaOfficialInfo.auditUserInfoLast = data.auditUserInfo;
    },
    saveAuditCommitTime(state, auditCommitTime) {
        state.topicData.ext.qaOfficialInfo.auditCommitTime = auditCommitTime;
    },
    setCheckedState(state, isCheckedState) {
        state.isCheckedNotRelatedIssue = isCheckedState;
    },
    initSelectedQuestionState(state, qaOfficialInfo) {
        state.selectedQuestionCategory = qaOfficialInfo.questionCategory > 0
            ? qaOfficialInfo.questionCategory : 0;
        state.selectedQuestionType = qaOfficialInfo.questionType > 0
            ? qaOfficialInfo.questionType : 0;
        state.selectedQuestionTag = qaOfficialInfo.questionTag > 0
            ? qaOfficialInfo.questionTag : 0;
        state.selectedBugLevel = qaOfficialInfo.questionLevel > -1
            ? qaOfficialInfo.questionLevel : -1;
    },
    setSelectedQuestionCategory(state, num) {
        state.selectedQuestionCategory = num;
    },
    setSelectedQuestionType(state, num) {
        state.selectedQuestionType = num;
    },
    setSelectedQuestionTag(state, num) {
        state.selectedQuestionTag = num;
    },
    setSelectedBugLevel(state, num) {
        state.selectedBugLevel = num;
    },
    setHasInputDetail(state, val) {
        state.hasInputDetail = val;
    },
    setIssueFilterProcess(state, val) {
        state.issueFilterProcess = val;
    },
    setIssueFilterTitle(state, str) {
        state.issueFilterTitle = str;
    },
    setIssueToCheckData(state, data) {
        state.issueToCheckData = Object.assign({}, data);
    }
};
